// Copyright 2026. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';
import { COLORS } from 'admin/core/theme';

// Shared bases for cells that stack a primary value above a muted caption. Each cell extends its
// own component rather than reusing these directly, so one cell's layout can be adjusted without
// silently moving the others.
const StackedCell = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

const CellCaption = styled.div`
    font-size: 11px;
    color: ${COLORS.GREY_60};
`;

export const ServersCell = styled(StackedCell)``;

export const RamCell = styled(StackedCell)``;

export const VirtualizationType = styled(CellCaption)``;

export const HostRam = styled(CellCaption)``;

export const RamUsage = styled.span`
    font-size: 13px;
    color: ${COLORS.GREY_90};
`;
